import { TagButton } from "@verde/ui-core";
import React, { useMemo } from "react";
import { TABS, useCreditProfilePanel } from "./panel";

function PanelNavigation() {
  const { client, currentTab, resource, setCurrentTab } =
    useCreditProfilePanel();

  return (
    <div className="rounded border border-neutral-light-2 bg-neutral-light-pure p-4">
      {TABS.filter(({ person_kind }) =>
        person_kind && client?.person_kind
          ? person_kind?.includes(client.person_kind)
          : true,
      )
        .filter(({ hide }) => !hide)
        .map((tab) => {
          const selected = currentTab === tab.id;

          return (
            <TagButton
              key={`credit-profile-tab-item-${tab.id}`}
              size="lg"
              kind={selected ? "secondary" : "primary"}
              {...(resource.available && {
                onClick: () => setCurrentTab(tab.id),
              })}
            >
              {tab.title}
            </TagButton>
          );
        })}
    </div>
  );
}

export default React.memo(PanelNavigation);
